module.exports = __webpack_public_path__ + "img/comparison-icon-blue.8d114e6.svg";